import { IServiceDeviceData } from "../../store/api/devices/types";

export const getAlarmsStatusCount = (tableRow: IServiceDeviceData) => {
  let status: string = "";
  let count: number = 0;

  if (tableRow.criticalAlarmCount > 0) {
    status = "Critical";
    count = tableRow.criticalAlarmCount;
  } else {
    if (tableRow.majorAlarmCount > 0) {
      status = "Major";
      count = tableRow.majorAlarmCount;
    } else {
      status = "";
      count = 0;
    }
  }
  return { status, count };
};
